import React from 'react';
import { Box } from '@mui/material';
import {
  HOMEPAGE_SECTION_PLACEHOLDER_HEIGHT,
  HOMEPAGE_SECTION_ROOT_MARGIN,
} from './homepageCarousel.constants';

/**
 * Renders children once the placeholder is within HOMEPAGE_SECTION_ROOT_MARGIN of the
 * screen, then keeps them mounted. Used for destination sections below the first one.
 */
class NearViewport extends React.Component {
  constructor(props) {
    super(props);
    this.state = { near: false };
    this.rootRef = React.createRef();
  }

  componentDidMount() {
    const node = this.rootRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      this.setState({ near: true });
      return;
    }
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer.disconnect();
        this.setState({ near: true });
      }
    }, { rootMargin: HOMEPAGE_SECTION_ROOT_MARGIN });
    this.observer.observe(node);
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  render() {
    if (this.state.near) return this.props.children;
    return (
      <Box
        id={this.props.sectionId}
        ref={this.rootRef}
        aria-hidden
        data-testid="near-viewport-placeholder"
        sx={{ width: '100%', minHeight: HOMEPAGE_SECTION_PLACEHOLDER_HEIGHT }}
      />
    );
  }
}

export default NearViewport;
